import MenuItemList from './MenuItemList/MenuItemList';

export const App = () => {
  return (
    <MenuItemList/>
  );
};



